module.exports = __webpack_public_path__ + "fonts/Vonnes-BoldCondItalic.5724de0d.otf";